import React from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Popover } from 'antd';
import { envKnowledgeBaseLink } from '../../../utils/envLinksUtil';
import { useStores } from '../../store';
import { EventType } from '../../../dtos/analytics.dto';
import KnowledgeBaseIcon from '@svg/book.svg?react';
import ReleaseNotesIcon from '@svg/release-notes.svg?react';
import './help-item.scss';

const HelpItem: React.FC = observer(() => {
    const { fwVersionStore } = useStores();

    const sendEvent = (buttonName: string) => {
        fwVersionStore.sendGeneralEvent(EventType.LinkClicked, { button: buttonName });
    };

    const links = [
        { to: `attdd`, label: 'Knowledge Base', icon: <KnowledgeBaseIcon />, event: 'knowledgeBase' },
        { to: `release-notes`, label: 'Release Notes', icon: <ReleaseNotesIcon />, event: 'releaseNotes' }
    ];

    const popoverContent = (
        <div className="help-item-popover-container">
            {links.map(link => (
                <Link
                    key={link.label}
                    to={`${envKnowledgeBaseLink}/${link.to}`}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => sendEvent(link.event)}
                    className="popover-link"
                >
                    {link.icon}
                    <span className="popover-text">{link.label}</span>
                </Link>
            ))}
        </div>
    );

    return (
        <div className="help-item">
            <Popover content={popoverContent} overlayClassName="help-item-popover" trigger="click" placement="bottom">
                <span className="question-mark">?</span>
            </Popover>
        </div>
    );
});

export default HelpItem;